/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Withdrawal_IntroInputs */

const en_consumer_declaration_withdrawal_intro = /** @type {(inputs: Consumer_Declaration_Withdrawal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a withdrawal within the applicable period without giving a reason. You receive an immediate savable receipt.`)
};

const de_consumer_declaration_withdrawal_intro = /** @type {(inputs: Consumer_Declaration_Withdrawal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklären Sie den Widerruf innerhalb der geltenden Frist ohne Angabe eines Grundes. Sie erhalten sofort eine speicherbare Eingangsbestätigung.`)
};

const fr_consumer_declaration_withdrawal_intro = /** @type {(inputs: Consumer_Declaration_Withdrawal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercez votre rétractation dans le délai applicable sans motif. Vous recevez immédiatement un reçu enregistrable.`)
};

const es_consumer_declaration_withdrawal_intro = /** @type {(inputs: Consumer_Declaration_Withdrawal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presenta el desistimiento dentro del plazo aplicable sin indicar motivo. Recibirás de inmediato un justificante guardable.`)
};

const it_consumer_declaration_withdrawal_intro = /** @type {(inputs: Consumer_Declaration_Withdrawal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercita il recesso entro il termine applicabile senza indicare un motivo. Riceverai subito una ricevuta salvabile.`)
};

const nl_consumer_declaration_withdrawal_intro = /** @type {(inputs: Consumer_Declaration_Withdrawal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dien binnen de geldende termijn zonder reden een herroeping in. Je ontvangt direct een bewaarbaar bewijs.`)
};

const pl_consumer_declaration_withdrawal_intro = /** @type {(inputs: Consumer_Declaration_Withdrawal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Złóż odstąpienie w obowiązującym terminie bez podawania powodu. Natychmiast otrzymasz zapisywalne potwierdzenie.`)
};

const fi_consumer_declaration_withdrawal_intro = /** @type {(inputs: Consumer_Declaration_Withdrawal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuta sovellettavan ajan kuluessa ilman syytä. Saat heti tallennettavan kuitin.`)
};

const da_consumer_declaration_withdrawal_intro = /** @type {(inputs: Consumer_Declaration_Withdrawal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortryd inden for den gældende frist uden at angive en grund. Du får straks en kvittering, der kan gemmes.`)
};

const sv_consumer_declaration_withdrawal_intro = /** @type {(inputs: Consumer_Declaration_Withdrawal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utöva ångerrätten inom gällande tid utan att ange skäl. Du får genast ett kvitto som kan sparas.`)
};

/**
* | output |
* | --- |
* | "Submit a withdrawal within the applicable period without giving a reason. You receive an immediate savable receipt." |
*
* @param {Consumer_Declaration_Withdrawal_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_withdrawal_intro = /** @type {((inputs?: Consumer_Declaration_Withdrawal_IntroInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Withdrawal_IntroInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_withdrawal_intro(inputs)
	if (locale === "fr") return fr_consumer_declaration_withdrawal_intro(inputs)
	if (locale === "es") return es_consumer_declaration_withdrawal_intro(inputs)
	if (locale === "it") return it_consumer_declaration_withdrawal_intro(inputs)
	if (locale === "nl") return nl_consumer_declaration_withdrawal_intro(inputs)
	if (locale === "pl") return pl_consumer_declaration_withdrawal_intro(inputs)
	if (locale === "fi") return fi_consumer_declaration_withdrawal_intro(inputs)
	if (locale === "da") return da_consumer_declaration_withdrawal_intro(inputs)
	if (locale === "sv") return sv_consumer_declaration_withdrawal_intro(inputs)
	return en_consumer_declaration_withdrawal_intro(inputs)
});